<img id="accorche-img" src="/images/271.jpg" alt="">
<div class="accroche">
    <img class="icon" src="/icons/star.svg" alt="">
    <h1>une éducation<br> par la nature,<br> partout et<br> pour tous.</h1>
    <div class="icons-wrapper">
        <img src="/icons/star.svg" alt="star">
        <img src="/icons/leaf.svg" alt="fourmis">
        <img src="/icons/wind.svg" alt="vent">
        <img src="/icons/water.svg" alt="water">
        <img src="/icons/loupe.svg" alt="loupe">
    </div>
    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero consequuntur neque suscipit rem officiis hic
        consectetur?
        <br>
        <br>

        delectus eaque natus earum maiores consequuntur sit et deserunt pariatur asperiores in. Debitis quis deleniti
        voluptatibus facilis, perferendis ducimus porro commodi temporibus quia vitae veniam explicabo. Veritatis enim
        modi magnam provident, animi fugiat, vero neque si Necessitatibus quae in quasi quod animi beatae
        dolore.

        <br>
        <br>
        Vluptatum modi exercitationem blanditiis magni veniam, harum, doloremque unde laborum?
    </p>
    <button href="#">en savoir plus</button>
</div>

<img class="arrow" src="/icons/arrow-bot.svg" alt="">